// client/plugins/ObsidianLinkPlugin/helper/index.ts
import { getFilteredLinks } from "./getFilteredLinks.js";
import { getSearchInput, getTextBeforeAndAfterInBrackets, hasInputAlreadyPipe } from "./getSearchInput.js";
import { parseLinkToTextNode } from "./parseLinkToText.js";
import { parseTextToLinkNode } from "./parseTextToLink.js";
var GlobalLinkHelper;
((GlobalLinkHelper2) => {
  let ParseNode;
  ((ParseNode2) => {
    ParseNode2.LinkToText = parseLinkToTextNode;
    ParseNode2.TextToLink = parseTextToLinkNode;
  })(ParseNode = GlobalLinkHelper2.ParseNode || (GlobalLinkHelper2.ParseNode = {}));
  let HandleInput;
  ((HandleInput2) => {
    HandleInput2.search = getSearchInput;
    HandleInput2.isInputAlreadyPiped = hasInputAlreadyPipe;
  })(HandleInput = GlobalLinkHelper2.HandleInput || (GlobalLinkHelper2.HandleInput = {}));
  GlobalLinkHelper2.filterLinks = getFilteredLinks;
  GlobalLinkHelper2.textBeforeAndAfterInBrackets = getTextBeforeAndAfterInBrackets;
})(GlobalLinkHelper || (GlobalLinkHelper = {}));
export {
  GlobalLinkHelper
};
